import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme: any) => ({
  welcomeScreen: {
    position: 'fixed',
    top: '0px',
    left: '0px',
    bottom: '0px',
    right: '0px',
    zIndex: theme.zIndex.screen,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backdropFilter: 'saturate(180%) blur(20px)',
    '& > svg': {
      maxWidth: '60%',
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    borderRadius: '24px',
    backgroundImage: 'linear-gradient(to bottom, #E0EDFF, #FFFFFF)',
    width: 'calc(80% - 96px)',
    height: 'calc(100% - 96px)',
    boxShadow: theme.shadows[2],
    [theme.breakpoints.down('xl')]: {
      width: 'calc(80% - 56px)',
      height: 'calc(100% - 56px)',
    },
    [theme.breakpoints.down('lg')]: {
      width: 'calc(80% - 26px)',
      height: 'calc(100% - 26px)',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: '100%',
      borderRadius: '0px',
    },
  },
  body: {
    display: 'flex',
    width: '100%',
    maxHeight: '100%',
    overflow: 'auto',
    height: '100%',
  },
  preloadImages: {
    width: '0px',
    height: '0px',
    visibility: 'hidden',
    '& > img': {
      width: '0px',
      height: '0px',
      visibility: 'hidden',
    },
  },
}));

export default useStyles;